import { Component } from 'san';
import { ELight } from 'src/enums';

export default class Light extends Component {
    constructor(options: any) {
        super(options);
    }

    static computed = {
        lightClass() {
            const status = this.data.get('status');
            switch (status) {
                case ELight.Green:
                    return 'green';
                case ELight.Yellow:
                    return 'yellow';
                case ELight.Red:
                    return 'red';
                case ELight.None:
                default:
                    return 'none';
            }
        }
    }

    initData() {
        return {
            status: null, // ELight
            lightEnum: ELight
        };
    }
}